import moment from 'moment'
import { useEffect, useRef } from 'react'
import { PROJECT_CODE } from '../constants/roles'

export const deepCopyObject = (obj = {}) => JSON.parse(JSON.stringify(obj))

export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const formatTime = timeInSeconds => {
  if (!timeInSeconds) return '00:00'
  const absoluteTime = Math.abs(timeInSeconds)
  const minutes = Math.floor(absoluteTime / 60)
  const seconds = Math.floor(absoluteTime % 60)
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export const getCodeByGroupName = name => {
  const trimmedName = name.trim()
  switch (trimmedName) {
    case 'Allur Auto':
      return 'allur'
    case 'autosell':
      return 'autosell'
    case 'DCG Group Auto':
      return 'doscar'
    case 'Aulet':
      return 'aulet'
    case 'Orbis Auto':
      return 'orbis'
    case 'Astana Motors':
      return 'mycar'
    case '4me':
      return '4me'
    case 'Aster Auto (Астэр Авто)':
      return 'aster'
    case 'avtorynok':
      return 'avtorynok'
    default:
      return null
  }
}

export const formatFileSize = size => {
  if (!size || typeof size !== 'number') {
    return 'Размер файла неизвестен'
  }
  return size > 1024 * 1024 ? `${(size / (1024 * 1024)).toFixed(1)} МБ` : `${(size / 1024).toFixed(0)} КБ`
}

export const getDiffDays = date => {
  const oneDay = 24 * 60 * 60 * 1000
  const firstDate = new Date()
  const secondDate = new Date(date)

  return Math.round(Math.abs((firstDate - secondDate) / oneDay))
}

export const getDiffTime = date => {
  if (date) {
    const now = moment(new Date())
    const then = moment(new Date(date))
    const ms = now.diff(then)
    return AddSecToMs(ms, 0)
  }
  return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    ms: 0
  }
}
export const getValidDate = (date, hasHours = false) => {
  if (!date) return '-'

  if (hasHours) {
    return moment(date).format('DD.MM.YYYY, HH:mm:ss')
  } else {
    return moment(date).format('DD.MM.YYYY')
  }
}
export function formatISODate(date, onlyDate = false) {
  if (!date) return null;
  const m = moment(date);
  if (!m.isValid()) return null;
  return onlyDate
    ? m.format('YYYY-MM-DD')
    : m.format('YYYY-MM-DDTHH:mm:ss');
}

export function formatDDMMYYYY(date) {
  if (!date) return null;
  let m = moment(date, moment.ISO_8601, true);

  if (!m.isValid()) {
    m = moment(date, 'DD.MM.YYYY', true);
  }
  return m.isValid()
    ? m.format('DD.MM.YYYY')
    : null;
}

export function parseDDMMYYYY(str) {
  if (!str) return null;
  const m = moment(str, 'DD.MM.YYYY', true);
  return m.isValid() ? m.toDate() : null;
}

export const parseToDate = (input) => {
  if (!input) return null
  if (input instanceof Date) return input

  const parsed = moment(input, ['DD-MM-YYYY', 'DD.MM.YYYY', moment.ISO_8601], true)
  return parsed.isValid() ? parsed.toDate() : null
}


export const AddSecToMs = (ms, sec = 1) => {
  const newMs = ms + sec * 1000
  const hours = moment.duration(newMs).hours()
  const minutes = moment.duration(newMs).minutes()
  const seconds = moment.duration(newMs).seconds()
  const days = Math.floor(moment.duration(newMs).asDays())
  return {
    days,
    hours,
    minutes,
    seconds,
    ms: newMs
  }
}

export const toTargetObj = (name, value) => ({ target: { name, value } })

export const toDate = dateStr => {
  if (dateStr) {
    const [day, month, year] = dateStr?.split('.')
    return new Date(year, month - 1, day) || null
  }
  return null
}

export const hasRole = (roles = [], user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !Array.isArray(roles) || !key) {
    return false
  }

  return user?.[key]?.some(e => roles.includes(e?.code) && e?.project?.code === PROJECT_CODE)
}

export const hasRoleByCode = (role = '', user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !role) {
    return false
  }

  return !!user?.[key]?.some(({ code, project }) => code === role && project?.code === PROJECT_CODE)
}

export const getUserRoleByToken = (user = {}, key = 'roles') => {
  if (!user || !user[key] || !Array.isArray(user[key])) {
    return null
  }

  const foundRole = user[key]?.find(({ project }) => project?.code === PROJECT_CODE)

  return foundRole?.code || null
}

export const sleep = async (timeout = 1000) => {
  await new Promise(resolve => setTimeout(resolve, timeout))
}

export const hasRoleById = (projectCode = '', role = '', user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !projectCode || !role) {
    return false
  }
  return user[key].some(item => item.code === role && item.project?.code === projectCode)
}

export const hasRoleByPosition = (role = '', user = {}, position, key = 'roles') => {
  if (!user || !user?.[key] || !role) {
    return false
  }

  const hasRoleInProject = user[key]?.some(({ code, project }) => code === role && project?.code === PROJECT_CODE)
  const hasSoftPosition = user.position === position

  return hasRoleInProject && hasSoftPosition
}

export const getFomattedDate = (date) => {
  const parsed = moment(date, ['DD-MM-YYYY', moment.ISO_8601, 'YYYY-MM-DD'], true)
  if (!parsed.isValid()) return date

  return parsed.format('DD.MM.YYYY')
}

export const getFormattedFiltersDate = (date) => {
  const parsed = moment(date, ['DD-MM-YYYY', moment.ISO_8601, 'YYYY-MM-DD'], true)
  if (!parsed.isValid()) return date

  return parsed.format('HH:mm:ss, DD.MM.YYYY')
}

export const getCurrentDay = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1 <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()

  return [year, month, day].join('-')
}

export const smartEnds = (n, w, o, s, m, full) => {
  if ((!!w || w === '') && (!!o || o === '') && (!!s || s === '') && (!!m || m === '') && (!!n || n === 0)) {
    n = n.toString()
    if ((n.length === 1 || n > 20) && n[n.length - 1] === '1') return n + (full ? '' : w) + o
    if ((n.length === 1 || n > 20) && n[n.length - 1] < 5 && n[n.length - 1] > 1) return n + (full ? '' : w) + s
    if (n[n.length - 1] > 4 || n[n.length - 1] === '0' || (n > 4 && n < 21)) return n + (full ? '' : w) + m
  } else {
    return n + w
  }
}

export const dateDiff = diff => {
  if (!diff) {
    return diff
  }
  const times = {
    ss: !!parseInt(moment(diff).utc().format('ss'))
      ? smartEnds(parseInt(moment(diff).utc().format('ss')), ' секунд', 'а', 'ы', '')
      : '',
    mm: !!parseInt(moment(diff).utc().format('mm'))
      ? smartEnds(parseInt(moment(diff).utc().format('mm')), ' минут', 'а', 'ы', '') + ' '
      : '',
    HH: !!parseInt(moment(diff).utc().format('HH'))
      ? smartEnds(parseInt(moment(diff).utc().format('HH')), ' час', '', 'а', 'ов') + ' '
      : '',
    DD: !!(parseInt(moment(diff).utc().format('DD')) - 1)
      ? smartEnds(parseInt(moment(diff).utc().format('DD')) - 1, ' день', ' день', ' дня', ' дней', true) + ' '
      : '',
    MM: !!(parseInt(moment(diff).utc().format('MM')) - 1)
      ? smartEnds(parseInt(moment(diff).utc().format('MM')) - 1, ' месяц', '', 'а', 'ев') + ' '
      : ''
  }
  if (diff < 60000) {
    return times.ss || ''
  }
  if (diff < 3600000) {
    return (times.mm || '') + (times.ss || '')
  }
  if (diff < 86400000) {
    return (times.HH || '') + (times.mm || '')
  }
  if (!(parseInt(moment(diff).utc().format('MM')) - 1)) {
    return (times.DD || '') + (times.HH || '') + (times.mm || '')
  }
  return (times.MM || '') + (times.DD || '') + (times.HH || '') + (times.mm || '')
}

export const deepCopyArrayOfObjects = arr => {
  const newArray = []

  arr.forEach(obj => {
    const newObj = Object.assign({}, obj)
    newArray.push(newObj)
  })

  return newArray
}

const noop = () => {}

export const useInterval = (callback, delay, immediate) => {
  const savedCallback = useRef(noop)

  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    if (!immediate || delay === null || delay === false) return
    savedCallback.current()
  }, [delay, immediate])

  useEffect(() => {
    if (delay === null || delay === false) return
    const tick = () => savedCallback.current()
    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

export const sortByName = arr => {
  return arr.sort((a, b) => {
    const nameA = a.toUpperCase()
    const nameB = b.toUpperCase()
    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    return 0
  })
}

export const flatDeep = (arr, d = 1) =>
  d > 0 ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), []) : arr.slice()

export const toBase64 = async file =>
  await new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
    } catch (e) {
      resolve(null)
    }
  })

export const toNumber = str => {
  const regex = /[\D\s]/g
  return Number(str.replace(regex, ''))
}

export const statusTrackDateToNormal = dateStr => {
  if (!dateStr) {
    return new Date().toJSON()
  }

  const [datePart, timePart] = dateStr.split('T')

  const [day, month, year] = datePart.split('.')
  const [hours, minutes] = timePart.split(':')

  const dayNum = parseInt(day, 10)
  const monthNum = parseInt(month, 10) - 1
  const yearNum = parseInt(year, 10)
  const hoursNum = parseInt(hours, 10)
  const minutesNum = parseInt(minutes, 10)

  return new Date(yearNum, monthNum, dayNum, hoursNum, minutesNum).toJSON()
}

export const hidePhoneNumber = (str, index = 4) => (str?.length ? str?.toString()?.replaceAt(index, '***') : str)

export const isValidDate = dateStr => !!new Date(dateStr).getDate()

export const getFullName = (firstName, lastName, patronymic, iin) => {
  const fullName = [lastName, firstName, patronymic].filter(Boolean).join(' ')
  return fullName || iin || '-'
}

export const onlyTextInput = e => {
  const value = e.target.value.replace(/[^a-zA-Zа-яА-ЯёЁәӘғҒқҚңҢөӨұҰүҮһҺіІ\s]/g, '')
  e.target.value = value
}

export const getTypeName = type => {
  switch (type) {
    case 'CLIENT':
      return 'Гарантия физ лиц'
    case 'LEGAL_CLIENT':
      return 'Гарантия юр лиц'
    case 'CAR':
      return 'На покупку автомобиля'
    case 'REAL_ESTATE':
      return 'Под залог недвижимости'
    default:
      return 'Нет данных'
  }
}

export const checkCreditProduct = (prefix, creditProduct) => {
  const prefixStr = String(prefix)
  const creditProductStr = String(creditProduct)

  return creditProductStr.startsWith(prefixStr)
}

export const getPledgeName = data => {
  switch (data?.type) {
    case 'CLIENT':
      return `Клиент`
    case 'LEGAL_CLIENT':
      return 'Гарантия юр лиц'
    case 'CAR':
      return `${getFullName(data?.brand, data?.model, data?.yearOfManufacture)}`
    case 'REAL_ESTATE':
      return 'Недвижимость'
    default:
      return 'Нет данных'
  }
}

export const getFullValue = (...parts) => {
  const value = parts.filter(Boolean).join(', ')
  return value || 'Нет данных'
}

export const getIinInputText = iinInput => {
  const remaining = 12 - iinInput.length
  const isNumeric = /^\d*$/.test(iinInput)

  if (!iinInput) {
    return 'Введите ИИН 12'
  } else if (!isNumeric || remaining < 0) {
    return 'Введите правильный ИИН'
  }

  return `Введите ИИН ${remaining}`
}

export const getDaysLabel = days => {
  if (days === 1) {
    return 'день'
  } else if (days >= 2 && days <= 4) {
    return 'дня'
  } else {
    return 'дней'
  }
}

export const sortByOverdueDays = (a, b) => (b.overdueDays || 0) - (a.overdueDays || 0)

export const getFirstDayOfMonth = () => {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export const getAge = date => {
  if (!date) return ''

  return `${moment().diff(moment(date), 'years')} лет`
}

export const normalizePhone = phone => {
  if (typeof phone !== 'string') return phone
  const cleaned = phone.replace(/\D/g, '')

  if (cleaned.length === 11 && /^[78]/.test(cleaned)) {
    return cleaned.slice(1)
  }

  return cleaned.length === 10 ? cleaned : phone
}


export const toErrorText = (err, fallback = 'Ошибка') => {
  if (!err) return fallback
  if (typeof err === 'string') return err
  if (err instanceof Error && err.message) return err.message

  if (err.response && err.response.data) {
    const d = err.response.data
    if (typeof d === 'string') return d
    if (d && typeof d.message === 'string') return d.message
    if (d && typeof d.error === 'string') return d.error
    if (d && typeof d.detail === 'string') return d.detail
  }

  if (typeof err.message === 'string') return err.message
  if (typeof err.msg === 'string') return err.msg
  if (typeof err.error === 'string') return err.error
  if (typeof err.detail === 'string') return err.detail

  try {
    return JSON.stringify(err)
  } catch (_) {
    return fallback
  }
}
